import { Fragment } from 'react';
import moment from 'moment';

import { SmartTableCellProps } from '@/components/ui/daisy';

import { ActivityProgress } from '@/models/ActivityProgress';

export default function SentAtCell({
  item,
}: SmartTableCellProps<Pick<ActivityProgress, 'sentAt'>>) {
  if (!item.sentAt) return null;

  return <Fragment>{moment(item.sentAt).format('DD/MM/YY - HH:mm')}</Fragment>;
}
